import { Injectable, Injector, inject } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { Observable, throwError } from 'rxjs';
import { __ } from '@app/shared/functions/object.functions';
import { Router } from '@angular/router';
import { ToastrService } from '@app/shared/services/toast.service';
import { LoadingBarService } from '@app/shared/services/local/loading-bar/loading-bar.service';
import { AppRoute } from '@app/shared/app.route.enum';

@Injectable()
export class AccessTokenInterceptor implements HttpInterceptor {
  private injector = inject(Injector);
  private router = inject(Router);
  private toastr = inject(ToastrService);
  private loadingBarService = inject(LoadingBarService);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Anonymous calls (login, forgot password, set password via emailed token)
    // opt out per request with HttpService.disableAccessToken(). Everything else
    // carries the bearer token. A URL-based heuristic used to live here and sent
    // PATCH users/me/password without a token, which broke changing the own password.
    const authenticationService = this.injector.get(AuthenticationService);
    if (__.IsNullOrUndefined(authenticationService.credentials)) {
      // TODO: implement a route save -> after login redirect to where the user was?
      authenticationService.logout();
      this.router.navigate([`/${AppRoute.Login}`]).then((_value) => {
        this.toastr.error('You are not logged in. Please login to continue');
        this.loadingBarService.complete();
      });
      return throwError(
        () => new Error('No bearer token is present but the user is trying to access an authorized route'),
      );
    }
    request = request.clone({
      setHeaders: { Authorization: `Bearer ${authenticationService.credentials.access_token}` },
    });
    return next.handle(request);
  }
}
